/**
 * Crockford base32 ULID, generated in the browser.
 *
 * The API requires a client generated ULID as the Idempotency-Key on every mutation.
 * A dependency for 30 lines was not worth it; this is monotonic within a millisecond so a
 * burst of clicks cannot produce two identical keys.
 */
const ENCODING = '0123456789ABCDEFGHJKMNPQRSTVWXYZ';
const TIME_LEN = 10;
const RANDOM_LEN = 16;

let lastTime = -1;
let lastRandom: number[] = [];

function randomBytes(length: number): number[] {
  const out = new Uint8Array(length);
  if (typeof globalThis.crypto?.getRandomValues === 'function') {
    globalThis.crypto.getRandomValues(out);
  } else {
    for (let i = 0; i < length; i += 1) out[i] = Math.floor(Math.random() * 256);
  }
  return Array.from(out, (b) => b % ENCODING.length);
}

function encodeTime(now: number): string {
  let time = now;
  let out = '';
  for (let i = 0; i < TIME_LEN; i += 1) {
    const mod = time % ENCODING.length;
    out = ENCODING[mod] + out;
    time = (time - mod) / ENCODING.length;
  }
  return out;
}

function bumpRandom(chars: number[]): number[] {
  const next = [...chars];
  for (let i = next.length - 1; i >= 0; i -= 1) {
    const value = next[i] ?? 0;
    if (value < ENCODING.length - 1) {
      next[i] = value + 1;
      return next;
    }
    next[i] = 0;
  }
  return randomBytes(RANDOM_LEN);
}

export function ulid(now: number = Date.now()): string {
  if (now === lastTime) {
    lastRandom = bumpRandom(lastRandom);
  } else {
    lastTime = now;
    lastRandom = randomBytes(RANDOM_LEN);
  }
  return encodeTime(now) + lastRandom.map((n) => ENCODING[n] ?? '0').join('');
}
